import React from 'react';
import { connect } from 'react-redux';

import SegmentWrapper from './components/Wrapper';

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default (store) => ({
  path : 'create',
  component: connect(mapStateToProps)(props => (
    <div className='container'>
      <div className='page-layout__viewport'>
        <SegmentWrapper {...props} />
      </div>
    </div>
  )),
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Create/index.js